import React from 'react';
import { Box, Typography } from '@mui/material';
import { STORY_UI } from '../../solution-stories/storyUiTokens';

export interface ReportCardProps {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  sx?: object;
}

/** Shared chrome for report widgets — Solution-Stories card styling (radius/shadow/border). */
export function ReportCard({ title, subtitle, action, children, sx }: ReportCardProps): React.ReactElement {
  return (
    <Box
      sx={{
        backgroundColor: STORY_UI.surface,
        border: `1px solid ${STORY_UI.line}`,
        borderRadius: STORY_UI.radiusLg,
        boxShadow: STORY_UI.shadowCard,
        p: 2.5,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        ...sx,
      }}
    >
      {(title || action) && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
          <Box>
            {title && (
              <Typography
                sx={{
                  fontFamily: STORY_UI.fontDisplay,
                  fontWeight: 600,
                  fontSize: '15px',
                  color: STORY_UI.ink,
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography sx={{ fontFamily: STORY_UI.fontSans, fontSize: '12px', color: STORY_UI.inkFaint, mt: 0.25 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      {children}
    </Box>
  );
}
